import React from "react";

function UserIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill={props?.bgfill ? props?.bgfill : "none"}
      viewBox="0 0 20 20"
    >
      <rect width="20" height="20" fill={props.bg_color} rx="10"></rect>
      <path
        fill={props?.iconfill ? props?.iconfill : "#000"}
        d="M14.367 13.38A5.23 5.23 0 0011.462 11a3.164 3.164 0 10-3.237 0 5.227 5.227 0 00-2.904 2.38.352.352 0 10.609.352c.827-1.431 2.29-2.285 3.914-2.285 1.623 0 3.086.854 3.914 2.285a.352.352 0 10.609-.352zM7.383 8.282a2.461 2.461 0 114.922 0 2.461 2.461 0 01-4.922 0z"
      ></path>
    </svg>
  );
}

export default UserIcon;
